module.exports = __webpack_public_path__ + "static/media/logosaweransm.48ce7eac.png";